// jinke's hidden audio-lists panel is the operational queue. Find the DOM
// item for a Redux entry by CONTENT (name+singer, with an ordinal for
// duplicates) — never by raw index: any divergence between jinke's internal
// list and Redux makes index clicks hit ghost tracks.
export const findJinkeQueueItem = (audioList, trackIndex) => {
    const track = audioList?.[trackIndex];
    if (!track) return null;
    const key = (t) => `${t?.name || ''}|||${t?.singer || ''}`;
    const ordinal = audioList.slice(0, trackIndex).filter(t => key(t) === key(track)).length;
    const items = Array.from(document.querySelectorAll('.react-jinke-music-player-main .audio-lists-panel .audio-item'));
    const matches = items.filter(el =>
        (el.querySelector('.player-name')?.getAttribute('title') || '') === (track.name || '')
        && (el.querySelector('.player-singer')?.getAttribute('title') || '') === (track.singer || ''));
    return matches[ordinal] || matches[0] || null;
};
